import React, { useState } from 'react';
import { identity, pick } from 'ramda';

import { InputDateDefault } from 'js/app/components/common/Fields/InputDate/components/InputDateDefault';
import { InputDateForAndroid } from 'js/app/components/common/Fields/InputDate/components/InputDateForAndroid';
import { InputDateForDesktopAndIOS } from 'js/app/components/common/Fields/InputDate/components/InputDateForDesktopAndIOS';
import { Control } from 'js/components/common/Fields/Control';

import { DEVICES } from '@interlayer/js/components/system/Page/buzz/constants';

import { clsx } from 'js/app/utils/clsx.util';
import withField from 'js/components/common/Fields/withField';
import { useDeviceSelector } from 'js/store/hooks';

import style from './InputDate.scss';

const InputDateBare = ({
    /* rff render props */
    input,
    meta,

    /* user provided props */
    isShowValidationIcon,
    name,
    label,
    hint,
    placeholder,
    isBorderHidden,
    resetFieldState = identity,
    classNames,
    withCurrentYear,
    ...inputDomProps
}) => {
    const { formFactor, os } = useDeviceSelector(pick(['formFactor', 'os']));
    const [isInputFocus, setIsInputFocus] = useState(false);
    const isForced = input.value.length || isInputFocus || !(formFactor === DEVICES.desktop || os === 'ios');
    const isAndroid = os === 'android';

    const renderInputDate = () => {
        if (formFactor === DEVICES.desktop || os === 'ios') {
            return (
                <InputDateForDesktopAndIOS
                    name={name}
                    meta={meta}
                    value={input.value}
                    isInputFocus={isInputFocus}
                    isShowValidationIcon={isShowValidationIcon}
                    setIsInputFocus={setIsInputFocus}
                    resetFieldState={resetFieldState}
                />
            );
        }

        if (isAndroid) {
            return <InputDateForAndroid meta={meta} name={name} value={input.value} withCurrentYear={withCurrentYear} />;
        }

        return (
            <InputDateDefault
                {...input}
                {...inputDomProps}
                type="date"
                name={name}
            />
        );
    };

    return (
        <Control
            {...{
                meta,
                label,
                name,
                hint,
                isInputFocus,
                isBorderHidden,
                animate: true,
                classNames: { control: classNames?.control },
                ...isAndroid && {
                    classNames: { content: style.isTransparent, control: classNames?.control },
                    className: clsx({ [style.isFocus]: isInputFocus })
                }
            }}
        >
            {renderInputDate()}

            {placeholder && (
                <span className={clsx(style.placeholder, { [style.forced]: isForced })}>
                    {placeholder}
                </span>
            )}
        </Control>
    );
};

export const InputDate = withField(InputDateBare);
